import { FunctionComponent } from 'react';
import { flexify } from '../../utilities/cssMixins';
import { Typography } from '@mui/material';

const ErrorBoundaryMessage: FunctionComponent<{ message?: string }> = ({
  message,
}) => {
  return (
    <div style={{ height: '80vh', width: '100%', ...flexify() }}>
      <Typography variant="h3">
        {message ||
          'An error occurred, and a report has been submitted to the site administrator. Please try refreshing your page.'}
      </Typography>
    </div>
  );
};

export default ErrorBoundaryMessage;
